import { Container, IResourceCache, TextureResource } from '@cgs/wge';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { LinesSceneObject } from '../../reels_engine/lines_scene_object';
import { RESOURCES_COMPONENT_TOKEN } from '../../type_definitions';
import { ResourcesComponent } from './resources_component';

export class LinesSceneObjectComponent {
  linesSceneObject: LinesSceneObject;
  constructor(container: Container, resourceCache: IResourceCache) {
    console.log('load ' + this.constructor.name);
    const res = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const textureResource = resourceCache.getResource<TextureResource>(
      TextureResource.TypeId,
      'line.png'
    );
    this.linesSceneObject = new LinesSceneObject();
    this.linesSceneObject.texture = textureResource!.data!;
    const linesHolder = res.slot.findById('lines_holder');
    linesHolder?.addChild(this.linesSceneObject);

    const gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    gameStateMachine.accelerate.entered.listen(() => this.linesSceneObject.clear());
  }
}
